/** Pulsing placeholder used while pricing data loads. */
export function Skeleton({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`animate-pulse rounded-md bg-pi-border-strong ${className}`}
    />
  );
}
